var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientIconDrink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#004887"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1009_1067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.574 35.5H24.426C24.1736 35.5007 23.9303 35.406 23.7448 35.2348C23.5593 35.0636 23.4454 34.8287 23.426 34.577L22.5 22.5H32.5L31.571 34.577C31.5516 34.8281 31.4382 35.0627 31.2533 35.2338C31.0685 35.4049 30.8259 35.5 30.574 35.5Z",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3588 19.5C22.9554 18.5373 22.6671 17.5303 22.4998 16.5V13.5H18.4998V16.5C18.4998 17.829 16.6568 21.03 16.6568 24.426C16.6568 27.822 17.1258 29.003 17.1258 30.626C17.1258 32.249 16.4998 33.1 16.4998 34.023C16.4839 34.3943 16.6143 34.7571 16.8631 35.0332C17.1118 35.3094 17.4589 35.477 17.8298 35.5H20.4998",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1009_1067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientIconDrink);
export default __webpack_public_path__ + "static/media/patient-icon-drink.4e2530bfa79d8d82a19c574c290662fe.svg";
export { ForwardRef as ReactComponent };